/* eslint-disable max-lines */
export const enum PageId {
  LIKE_OR_DISLIKE = 'like_or_dislike',
  CANCEL_OFFER = 'cancel_offer',
  DOWNLOAD = 'download',
  PAYMENT = 'payment',
  ACCOUNT_NOVE8 = 'account_nove8',

  DISCOVER_YOUR_PERSONAL_STYLE = 'discover_your_personal_style',
  AGE = 'age',
  URGE = 'urge',
  BODY_SHAPE = 'body_shape',
  STYLIO_TO_HELP = 'stylio_to_help',
  EMAIL = 'email',
  ACCOUNT = 'account',
  SHOPPING = 'shopping',
  STYLE_MOST_MATTERS = 'style_most_matters',
  BRAND = 'brand',
  UPSELL_SNRS = 'upsell_snrs',
  UPSELL_SNRS_2 = 'upsell_snrs2',
  SUB_UPSELL_SNRS = 'sub_upsell_snrs',
  SUB_UPSELL_SNRS2 = 'sub_upsell_snrs2',
  START_SCREEN = 'start_screen',
  STYLES_FEEL_LIKE_YOU = 'styles_feel_like_you',

  // SNRS
  LIKE_OR_DISLIKE_SNRS = 'like_or_dislike_snrs',
  LIKE_OR_DISLIKE_11_SNRS = 'like_or_dislike_11_snrs',
  LIKE_OR_DISLIKE_12_SNRS = 'like_or_dislike_12_snrs',
  LIKE_OR_DISLIKE_13_SNRS = 'like_or_dislike_13_snrs',
  LIKE_OR_DISLIKE_14_SNRS = 'like_or_dislike_14_snrs',
  LIKE_OR_DISLIKE_15_SNRS = 'like_or_dislike_15_snrs',
  LIKE_OR_DISLIKE_16_SNRS = 'like_or_dislike_16_snrs',
  LIKE_OR_DISLIKE_17_SNRS = 'like_or_dislike_17_snrs',
  STYLES_FEEL_LIKE_YOU_SNRS = 'styles_feel_like_you_snrs',
  URGE_4_SNRS = 'urge_4_snrs',
  OUTFIT_LOOK_SNRS = 'outfit_look_snrs',
  EVERYDAY_LIFESTYLE_SNRS = 'everyday_lifestyle_snrs',
  PREPARE_FLOW_SNRS = 'prepare_flow_snrs',
  OPTIMIZE_BUDGET_SNRS = 'optimize_budget_snrs',
  SUBSCRIPTIONS_SNRS = 'subscriptions_snrs',
  CLIMAT_SNRS = 'climat_snrs',
  EMAIL_SNRS = 'email_snrs',
  EMAIL_CONSENT_SNRS = 'email_consent_snrs',
  FAVORITE_COLORS_SNRS = 'favorite_colors_snrs',
  SHOPPING_SNRS = 'shopping_snrs',
  STYLE_MOST_MATTERS_SNRS = 'style_most_matters_snrs',
  NOTHING_TO_WEAR_SNRS = 'nothing_to_wear_snrs',
  OLD_CLOTHES_SNRS = 'old_clothes_snrs',
  COMBINE_CLOTHES_SNRS = 'combine_clothes_snrs',
  HAIR_COLOR_SNRS = 'hair_color_snrs',
  EYES_COLOR_SNRS = 'eyes_color_snrs',
  JEWELRY_SNRS = 'jewelry_snrs',
  BRAND_SNRS = 'brand_snrs',
  TALL_SNRS = 'tall_snrs',
  WEIGHT_SNRS = 'weight_snrs',
  URGE_SNRS = 'urge_snrs',
  URGE_2_SNRS = 'urge_2_snrs',
  URGE_3_SNRS = 'urge_3_snrs',
  BODY_SHAPE_SNRS = 'body_shape_snrs',
  STYLIO_TO_HELP_SNRS = 'stylio_to_help_snrs',
  // PAYMENT_SNRS = 'payment_snrs',
  // LAST_CHANCE_OFFER_SNRS = 'last_chance_offer_snrs',
  CANCEL_OFFER_SNRS = 'cancel_offer_snrs',
  AGE_SNRS = 'age_snrs',
  FIND_NEW_CLOTHES_SNRS = 'find_new_clothes_snrs',
  DOWNLOAD_SNRS = 'download_snrs',

  // SNRS IO
  LIKE_OR_DISLIKE_SNRS_IO = 'like_or_dislike_snrs_io',
  LIKE_OR_DISLIKE_11_SNRS_IO = 'like_or_dislike_11_snrs_io',
  LIKE_OR_DISLIKE_12_SNRS_IO = 'like_or_dislike_12_snrs_io',
  LIKE_OR_DISLIKE_13_SNRS_IO = 'like_or_dislike_13_snrs_io',
  LIKE_OR_DISLIKE_14_SNRS_IO = 'like_or_dislike_14_snrs_io',
  LIKE_OR_DISLIKE_15_SNRS_IO = 'like_or_dislike_15_snrs_io',
  LIKE_OR_DISLIKE_16_SNRS_IO = 'like_or_dislike_16_snrs_io',
  LIKE_OR_DISLIKE_17_SNRS_IO = 'like_or_dislike_17_snrs_io',
  STYLES_FEEL_LIKE_YOU_SNRS_IO = 'styles_feel_like_you_snrs_io',
  URGE_4_SNRS_IO = 'urge_4_snrs_io',
  OUTFIT_LOOK_SNRS_IO = 'outfit_look_snrs_io',
  EVERYDAY_LIFESTYLE_SNRS_IO = 'everyday_lifestyle_snrs_io',
  PREPARE_FLOW_SNRS_IO = 'prepare_flow_snrs_io',
  OPTIMIZE_BUDGET_SNRS_IO = 'optimize_budget_snrs_io',
  SUBSCRIPTIONS_SNRS_IO = 'subscriptions_snrs_io',
  CLIMAT_SNRS_IO = 'climat_snrs_io',
  EMAIL_SNRS_IO = 'email_snrs_io',
  EMAIL_CONSENT_SNRS_IO = 'email_consent_snrs_io',
  FAVORITE_COLORS_SNRS_IO = 'favorite_colors_snrs_io',
  SHOPPING_SNRS_IO = 'shopping_snrs_io',
  STYLE_MOST_MATTERS_SNRS_IO = 'style_most_matters_snrs_io',
  NOTHING_TO_WEAR_SNRS_IO = 'nothing_to_wear_snrs_io',
  OLD_CLOTHES_SNRS_IO = 'old_clothes_snrs_io',
  COMBINE_CLOTHES_SNRS_IO = 'combine_clothes_snrs_io',
  HAIR_COLOR_SNRS_IO = 'hair_color_snrs_io',
  EYES_COLOR_SNRS_IO = 'eyes_color_snrs_io',
  JEWELRY_SNRS_IO = 'jewelry_snrs_io',
  BRAND_SNRS_IO = 'brand_snrs_io',
  TALL_SNRS_IO = 'tall_snrs_io',
  WEIGHT_SNRS_IO = 'weight_snrs_io',
  URGE_SNRS_IO = 'urge_snrs_io',
  URGE_2_SNRS_IO = 'urge_2_snrs_io',
  URGE_3_SNRS_IO = 'urge_3_snrs_io',
  BODY_SHAPE_SNRS_IO = 'body_shape_snrs_io',
  STYLIO_TO_HELP_SNRS_IO = 'stylio_to_help_snrs_io',
  CANCEL_OFFER_SNRS_IO = 'cancel_offer_snrs_io',
  AGE_SNRS_IO = 'age_snrs_io',
  FIND_NEW_CLOTHES_SNRS_IO = 'find_new_clothes_snrs_io',
  DOWNLOAD_SNRS_IO = 'download_snrs_io',
  UPSELL_SNRS_IO = 'upsell_snrs_io',
  AI_STYLIST_UPSELL_SNRS_IO = 'ai_stylist_upsell_snrs_io',
  SUB_UPSELL_SNRS_IO = 'sub_upsell_snrs_io',

  // SNRS 2
  LIKE_OR_DISLIKE_SNRS2_1 = 'like_or_dislike_snrs2_1',
  LIKE_OR_DISLIKE_SNRS2_2 = 'like_or_dislike_snrs2_2',
  LIKE_OR_DISLIKE_SNRS2_3 = 'like_or_dislike_snrs2_3',
  LIKE_OR_DISLIKE_SNRS2_4 = 'like_or_dislike_snrs2_4',
  LIKE_OR_DISLIKE_SNRS2_5 = 'like_or_dislike_snrs2_5',
  LIKE_OR_DISLIKE_SNRS2_6 = 'like_or_dislike_snrs2_6',
  LIKE_OR_DISLIKE_SNRS2_7 = 'like_or_dislike_snrs2_7',
  LIKE_OR_DISLIKE_SNRS2_8 = 'like_or_dislike_snrs2_8',
  PREPARE_FLOW_SNRS2 = 'prepare_flow_snrs2',
  OPTIMIZE_BUDGET_SNRS2 = 'optimize_budget_snrs2',
  SUBSCRIPTIONS_SNRS2 = 'subscriptions_snrs2',
  EMAIL_SNRS2 = 'email_snrs2',
  FAVORITE_COLORS_SNRS2 = 'favorite_colors_snrs2',
  SHOPPING_SNRS2 = 'shopping_snrs2',
  STYLE_MOST_MATTERS_SNRS2 = 'style_most_matters_snrs2',
  NOTHING_TO_WEAR_SNRS2 = 'nothing_to_wear_snrs2',
  OLD_CLOTHES_SNRS2 = 'old_clothes_snrs2',
  COMBINE_CLOTHES_SNRS2 = 'combine_clothes_snrs2',
  HAIR_COLOR_SNRS2 = 'hair_color_snrs2',
  EYES_COLOR_SNRS2 = 'eyes_color_snrs2',
  JEWELRY_SNRS2 = 'jewelry_snrs2',
  BRAND_SNRS2 = 'brand_snrs2',
  TALL_SNRS2 = 'tall_snrs2',
  WEIGHT_SNRS2 = 'weight_snrs2',
  URGE_SNRS2 = 'urge_snrs2',
  URGE_2_SNRS2 = 'urge_2_snrs2',
  URGE_3_SNRS2 = 'urge_3_snrs2',
  BODY_SHAPE_SNRS2 = 'body_shape_snrs2',
  STYLIO_TO_HELP_SNRS2 = 'stylio_to_help_snrs2',
  CANCEL_OFFER_SNRS2 = 'cancel_offer_snrs2',
  AGE_SNRS2 = 'age_snrs2',
  FIND_NEW_CLOTHES_SNRS2 = 'find_new_clothes_snrs2',
  URGE_4_SNRS2 = 'urge_4_snrs2',
  STYLES_FEEL_LIKE_YOU_SNRS2 = 'styles_feel_like_you_snrs2',
  OUTFIT_LOOK_SNRS2 = 'outfit_look_snrs2',
  EVERYDAY_LIFESTYLE_SNRS2 = 'everyday_lifestyle_snrs2',
  CLIMAT_SNRS2 = 'climat_snrs2',
  DOWNLOAD_SNRS2 = 'download_snrs2',

  // STYLIO_CAPSULE
  AGE_CAPSULE = 'age_capsule',
  URGE_CAPSULE = 'urge_capsule',
  HAIR_COLOR_CAPSULE = 'hair_color_capsule',
  EYES_COLOR_CAPSULE = 'eyes_color_capsule',
  JEWELRY_CAPSULE = 'jewelry_capsule',
  BODY_SHAPE_CAPSULE = 'body_shape_capsule',
  OUTFIT_STRUGGLES_CAPSULE = 'outfit_struggles_capsule',
  STYLIO_TO_HELP_CAPSULE = 'stylio_to_help_capsule',
  TALL_CAPSULE = 'tall_capsule',
  WEIGHT_CAPSULE = 'weight_capsule',
  BODY_COMFORT_CAPSULE = 'body_comfort_capsule',
  WHAT_YOU_WEAR_CAPSULE = 'what_you_wear_capsule',
  URGE_2_CAPSULE = 'urge_2_capsule',
  FEEL_ABOUT_CAPSULE = 'feel_about_capsule',
  WARDROBE_USAGE_CAPSULE = 'wardrobe_usage_capsule',
  NOT_ALONE_CAPSULE = 'not_alone_capsule',
  PERCENTAGE_CAPSULE = 'percentage_capsule',
  SHOPPING_CAPSULE = 'shopping_capsule',
  STYLE_MOST_MATTERS_CAPSULE = 'style_most_matters_capsule',
  YOUR_LOCATION_CAPSULE = 'your_location_capsule',
  FAVORITE_COLORS_CAPSULE = 'favorite_colors_capsule',
  LIKE_OR_DISLIKE_CAPSULE = 'like_or_dislike_capsule',
  LIKE_OR_DISLIKE_11_CAPSULE = 'like_or_dislike_11_capsule',
  LIKE_OR_DISLIKE_12_CAPSULE = 'like_or_dislike_12_capsule',
  LIKE_OR_DISLIKE_13_CAPSULE = 'like_or_dislike_13_capsule',
  LIKE_OR_DISLIKE_14_CAPSULE = 'like_or_dislike_14_capsule',
  LIKE_OR_DISLIKE_15_CAPSULE = 'like_or_dislike_15_capsule',
  LIKE_OR_DISLIKE_16_CAPSULE = 'like_or_dislike_16_capsule',
  LIKE_OR_DISLIKE_17_CAPSULE = 'like_or_dislike_17_capsule',
  LIKE_OR_DISLIKE_18_CAPSULE = 'like_or_dislike_18_capsule',
  LIKE_OR_DISLIKE_19_CAPSULE = 'like_or_dislike_19_capsule',
  SEE_YOURSELF_CAPSULE = 'see_yourself_capsule',
  STYLES_FEEL_LIKE_YOU_CAPSULE = 'styles_feel_like_you_capsule',
  URGE_3_CAPSULE = 'urge_3_capsule',
  BRAND_CAPSULE = 'brand_capsule',
  FIND_NEW_CLOTHES_CAPSULE = 'find_new_clothes_capsule',
  NOTHING_TO_WEAR_CAPSULE = 'nothing_to_wear_capsule',
  OLD_CLOTHES_CAPSULE = 'old_clothes_capsule',
  COMBINE_CLOTHES_CAPSULE = 'combine_clothes_capsule',
  OPTIMIZE_BUDGET_CAPSULE = 'optimize_budget_capsule',
  URGE_4_CAPSULE = 'urge_4_capsule',
  WHAT_YOU_WILL_FIND_CAPSULE = 'what_you_will_find_capsule',
  PREPARE_FLOW_CAPSULE = 'prepare_flow_capsule',
  EMAIL_CAPSULE = 'email_capsule',
  SUBSCRIPTIONS_CAPSULE = 'subscriptions_capsule',
  CANCEL_OFFER_CAPSULE = 'cancel_offer_capsule',
  SUB_UPSELL_CAPSULE = 'sub_upsell_capsule',
  UPSELL_CAPSULE = 'upsell_capsule',
  THIRD_PDF_UPSELL_CAPSULE = 'third_pdf_upsell_capsule',
  BUNDLE_UPSELL_CAPSULE = 'bundle_upsell_capsule',
  DOWNLOAD_CAPSULE = 'download_capsule',
  EMAIL_CONSENT_CAPSULE = 'email_consent_capsule',

  // STYLIO_CAPSULE_IO
  AGE_CAPSULE_IO = 'age_capsule_io',
  URGE_CAPSULE_IO = 'urge_capsule_io',
  HAIR_COLOR_CAPSULE_IO = 'hair_color_capsule_io',
  EYES_COLOR_CAPSULE_IO = 'eyes_color_capsule_io',
  JEWELRY_CAPSULE_IO = 'jewelry_capsule_io',
  BODY_SHAPE_CAPSULE_IO = 'body_shape_capsule_io',
  OUTFIT_STRUGGLES_CAPSULE_IO = 'outfit_struggles_capsule_io',
  STYLIO_TO_HELP_CAPSULE_IO = 'stylio_to_help_capsule_io',
  TALL_CAPSULE_IO = 'tall_capsule_io',
  WEIGHT_CAPSULE_IO = 'weight_capsule_io',
  BODY_COMFORT_CAPSULE_IO = 'body_comfort_capsule_io',
  WHAT_YOU_WEAR_CAPSULE_IO = 'what_you_wear_capsule_io',
  URGE_2_CAPSULE_IO = 'urge_2_capsule_io',
  FEEL_ABOUT_CAPSULE_IO = 'feel_about_capsule_io',
  WARDROBE_USAGE_CAPSULE_IO = 'wardrobe_usage_capsule_io',
  NOT_ALONE_CAPSULE_IO = 'not_alone_capsule_io',
  PERCENTAGE_CAPSULE_IO = 'percentage_capsule_io',
  SHOPPING_CAPSULE_IO = 'shopping_capsule_io',
  STYLE_MOST_MATTERS_CAPSULE_IO = 'style_most_matters_capsule_io',
  YOUR_LOCATION_CAPSULE_IO = 'your_location_capsule_io',
  FAVORITE_COLORS_CAPSULE_IO = 'favorite_colors_capsule_io',
  LIKE_OR_DISLIKE_CAPSULE_IO = 'like_or_dislike_capsule_io',
  LIKE_OR_DISLIKE_11_CAPSULE_IO = 'like_or_dislike_11_capsule_io',
  LIKE_OR_DISLIKE_12_CAPSULE_IO = 'like_or_dislike_12_capsule_io',
  LIKE_OR_DISLIKE_13_CAPSULE_IO = 'like_or_dislike_13_capsule_io',
  LIKE_OR_DISLIKE_14_CAPSULE_IO = 'like_or_dislike_14_capsule_io',
  LIKE_OR_DISLIKE_15_CAPSULE_IO = 'like_or_dislike_15_capsule_io',
  LIKE_OR_DISLIKE_16_CAPSULE_IO = 'like_or_dislike_16_capsule_io',
  LIKE_OR_DISLIKE_17_CAPSULE_IO = 'like_or_dislike_17_capsule_io',
  LIKE_OR_DISLIKE_18_CAPSULE_IO = 'like_or_dislike_18_capsule_io',
  LIKE_OR_DISLIKE_19_CAPSULE_IO = 'like_or_dislike_19_capsule_io',
  SEE_YOURSELF_CAPSULE_IO = 'see_yourself_capsule_io',
  STYLES_FEEL_LIKE_YOU_CAPSULE_IO = 'styles_feel_like_you_capsule_io',
  URGE_3_CAPSULE_IO = 'urge_3_capsule_io',
  BRAND_CAPSULE_IO = 'brand_capsule_io',
  FIND_NEW_CLOTHES_CAPSULE_IO = 'find_new_clothes_capsule_io',
  NOTHING_TO_WEAR_CAPSULE_IO = 'nothing_to_wear_capsule_io',
  OLD_CLOTHES_CAPSULE_IO = 'old_clothes_capsule_io',
  COMBINE_CLOTHES_CAPSULE_IO = 'combine_clothes_capsule_io',
  OPTIMIZE_BUDGET_CAPSULE_IO = 'optimize_budget_capsule_io',
  URGE_4_CAPSULE_IO = 'urge_4_capsule_io',
  WHAT_YOU_WILL_FIND_CAPSULE_IO = 'what_you_will_find_capsule_io',
  PREPARE_FLOW_CAPSULE_IO = 'prepare_flow_capsule_io',
  EMAIL_CAPSULE_IO = 'email_capsule_io',
  SUBSCRIPTIONS_CAPSULE_IO = 'subscriptions_capsule_io',
  CANCEL_OFFER_CAPSULE_IO = 'cancel_offer_capsule_io',
  AI_STYLIST_UPSELL_CAPSULE_IO = 'ai_stylist_upsell_capsule_io',
  SUB_UPSELL_CAPSULE_IO = 'sub_upsell_capsule_io',
  UPSELL_CAPSULE_IO = 'upsell_capsule_io',
  FACE_UPSELL_CAPSULE_IO = 'face_upsell_capsule_io',
  BUNDLE_UPSELL_CAPSULE_IO = 'bundle_upsell_capsule_io',
  DOWNLOAD_CAPSULE_IO = 'download_capsule_io',
  EMAIL_CONSENT_CAPSULE_IO = 'email_consent_capsule_io',

  // STYLIO_CMP2
  AGE_CMP2 = 'age_cmp2',
  CURRENT_WARDROBE_CMP2 = 'current_wardrobe_cmp2',
  URGE_1_CMP2 = 'urge_1_cmp2',
  WARDROBE_GOAL_CMP2 = 'wardrobe_goal_cmp2',
  HAIR_COLOR_CMP2 = 'hair_color_cmp2',
  EYES_COLOR_CMP2 = 'eyes_color_cmp2',
  SKIN_COLOR_CMP2 = 'skin_color_cmp2',
  JEWELRY_CMP2 = 'jewelry_cmp2',
  COLOR_PALETTE_CMP2 = 'color_palette_cmp2',
  COLOR_HARMONY_CMP2 = 'color_harmony_cmp2',
  URGE_6_CMP2 = 'urge_6_cmp2',
  BODY_SHAPE_CMP2 = 'body_shape_cmp2',
  TALL_CMP2 = 'tall_cmp2',
  WEIGHT_CMP2 = 'weight_cmp2',
  URGE_5_CMP2 = 'urge_5_cmp2',
  FEEL_ABOUT_CMP2 = 'feel_about_cmp2',
  URGE_2_CMP2 = 'urge_2_cmp2',
  STYLE_COMPLIMENTS_CMP2 = 'style_compliments_cmp2',
  PERCENTAGE_CMP2 = 'percentage_cmp2',
  SHOPPING_CMP2 = 'shopping_cmp2',
  STYLE_MOST_MATTERS_CMP2 = 'style_most_matters_cmp2',
  LIKE_OR_DISLIKE_CMP2 = 'like_or_dislike_cmp2',
  LIKE_OR_DISLIKE_11_CMP2 = 'like_or_dislike_11_cmp2',
  LIKE_OR_DISLIKE_12_CMP2 = 'like_or_dislike_12_cmp2',
  LIKE_OR_DISLIKE_13_CMP2 = 'like_or_dislike_13_cmp2',
  LIKE_OR_DISLIKE_14_CMP2 = 'like_or_dislike_14_cmp2',
  LIKE_OR_DISLIKE_15_CMP2 = 'like_or_dislike_15_cmp2',
  LIKE_OR_DISLIKE_16_CMP2 = 'like_or_dislike_16_cmp2',
  LIKE_OR_DISLIKE_17_CMP2 = 'like_or_dislike_17_cmp2',
  LIKE_OR_DISLIKE_18_CMP2 = 'like_or_dislike_18_cmp2',
  LIKE_OR_DISLIKE_19_CMP2 = 'like_or_dislike_19_cmp2',
  STYLES_FEEL_LIKE_YOU_CMP2 = 'styles_feel_like_you_cmp2',
  URGE_3_CMP2 = 'urge_3_cmp2',
  URGE_4_CMP2 = 'urge_4_cmp2',
  BODY_SHAPE_CONFIDENCE_CMP2 = 'body_shape_confidence_cmp2',
  OUTFIT_ON_OTHERS_CMP2 = 'outfit_on_others_cmp2',
  DRAW_LESS_ATTENTION_CMP2 = 'draw_less_attention_cmp2',
  BRAND_CMP2 = 'brand_cmp2',
  AVOID_COLORS_CMP2 = 'avoid_colors_cmp2',
  AVOIDED_COLORS_CMP2 = 'avoided_colors_cmp2',
  URGE_7_CMP2 = 'urge_7_cmp2',
  FIND_NEW_CLOTHES_CMP2 = 'find_new_clothes_cmp2',
  JACKET_COAT_BUDGET_CMP2 = 'jacket_coat_budget_cmp2',
  TOP_BUDGET_CMP2 = 'top_budget_cmp2',
  BOTTOM_BUDGET_CMP2 = 'bottom_budget_cmp2',
  SHOES_BUDGET_CMP2 = 'shoes_budget_cmp2',
  EXCITED_CAPSULE_PLAN_CMP2 = 'excited_capsule_plan_cmp2',
  URGE_8_CMP2 = 'urge_8_cmp2',
  YOUR_LOCATION_CMP2 = 'your_location_cmp2',
  WARDROBE_REFRESH_CMP2 = 'wardrobe_refresh_cmp2',
  SEASON_CHANGE_CHALLENGES_CMP2 = 'season_change_challenges_cmp2',
  LIFESTYLE_MATCH_CMP2 = 'lifestyle_match_cmp2',
  WEEKEND_ACTIVITIES_CMP2 = 'weekend_activities_cmp2',
  OUTFIT_OCCASIONS_CMP2 = 'outfit_occasions_cmp2',
  QUIZ_SUMMARY_CMP2 = 'quiz_summary_cmp2',
  PREPARE_FLOW_CMP2 = 'prepare_flow_cmp2',
  EMAIL_CMP2 = 'email_cmp2',
  SUBSCRIPTIONS_CMP2 = 'subscriptions_cmp2',
  CANCEL_OFFER_CMP2 = 'cancel_offer_cmp2',
  SUB_UPSELL_CMP2 = 'sub_upsell_cmp2',
  UPSELL_CMP2 = 'upsell_cmp2',
  DOWNLOAD_CMP2 = 'download_cmp2',
  EMAIL_CONSENT_CMP2 = 'email_consent_cmp2',

  // STYLIO_CAPSULE3
  AGE_CAPSULE3 = 'age_capsule3',
  URGE_CAPSULE3 = 'urge_capsule3',
  HAIR_COLOR_CAPSULE3 = 'hair_color_capsule3',
  EYES_COLOR_CAPSULE3 = 'eyes_color_capsule3',
  JEWELRY_CAPSULE3 = 'jewelry_capsule3',
  BODY_SHAPE_CAPSULE3 = 'body_shape_capsule3',
  STYLIO_TO_HELP_CAPSULE3 = 'stylio_to_help_capsule3',
  TALL_CAPSULE3 = 'tall_capsule3',
  WEIGHT_CAPSULE3 = 'weight_capsule3',
  URGE_2_CAPSULE3 = 'urge_2_capsule3',
  FEEL_ABOUT_CAPSULE3 = 'feel_about_capsule3',
  PERCENTAGE_CAPSULE3 = 'percentage_capsule3',
  SHOPPING_CAPSULE3 = 'shopping_capsule3',
  STYLE_MOST_MATTERS_CAPSULE3 = 'style_most_matters_capsule3',
  FAVORITE_COLORS_CAPSULE3 = 'favorite_colors_capsule3',
  LIKE_OR_DISLIKE_CAPSULE3 = 'like_or_dislike_capsule3',
  LIKE_OR_DISLIKE_11_CAPSULE3 = 'like_or_dislike_11_capsule3',
  LIKE_OR_DISLIKE_12_CAPSULE3 = 'like_or_dislike_12_capsule3',
  LIKE_OR_DISLIKE_13_CAPSULE3 = 'like_or_dislike_13_capsule3',
  LIKE_OR_DISLIKE_14_CAPSULE3 = 'like_or_dislike_14_capsule3',
  LIKE_OR_DISLIKE_15_CAPSULE3 = 'like_or_dislike_15_capsule3',
  LIKE_OR_DISLIKE_16_CAPSULE3 = 'like_or_dislike_16_capsule3',
  LIKE_OR_DISLIKE_17_CAPSULE3 = 'like_or_dislike_17_capsule3',
  LIKE_OR_DISLIKE_18_CAPSULE3 = 'like_or_dislike_18_capsule3',
  LIKE_OR_DISLIKE_19_CAPSULE3 = 'like_or_dislike_19_capsule3',
  STYLES_FEEL_LIKE_YOU_CAPSULE3 = 'styles_feel_like_you_capsule3',
  URGE_3_CAPSULE3 = 'urge_3_capsule3',
  BRAND_CAPSULE3 = 'brand_capsule3',
  FIND_NEW_CLOTHES_CAPSULE3 = 'find_new_clothes_capsule3',
  NOTHING_TO_WEAR_CAPSULE3 = 'nothing_to_wear_capsule3',
  OLD_CLOTHES_CAPSULE3 = 'old_clothes_capsule3',
  COMBINE_CLOTHES_CAPSULE3 = 'combine_clothes_capsule3',
  OPTIMIZE_BUDGET_CAPSULE3 = 'optimize_budget_capsule3',
  URGE_4_CAPSULE3 = 'urge_4_capsule3',
  PREPARE_FLOW_CAPSULE3 = 'prepare_flow_capsule3',
  EMAIL_CAPSULE3 = 'email_capsule3',
  SUBSCRIPTIONS_CAPSULE3 = 'subscriptions_capsule3',
  CANCEL_OFFER_CAPSULE3 = 'cancel_offer_capsule3',
  SUB_UPSELL_CAPSULE3 = 'sub_upsell_capsule3',
  UPSELL_CAPSULE3 = 'upsell_capsule3',
  DOWNLOAD_CAPSULE3 = 'download_capsule3',
  EMAIL_CONSENT_CAPSULE3 = 'email_consent_capsule3',

  // STYLIO_CAPSEN
  AGE_CAPSEN = 'age_capsen',
  URGE_CAPSEN = 'urge_capsen',
  HAIR_COLOR_CAPSEN = 'hair_color_capsen',
  EYES_COLOR_CAPSEN = 'eyes_color_capsen',
  JEWELRY_CAPSEN = 'jewelry_capsen',
  BODY_SHAPE_CAPSEN = 'body_shape_capsen',
  STYLIO_TO_HELP_CAPSEN = 'stylio_to_help_capsen',
  TALL_CAPSEN = 'tall_capsen',
  WEIGHT_CAPSEN = 'weight_capsen',
  URGE_2_CAPSEN = 'urge_2_capsen',
  FEEL_ABOUT_CAPSEN = 'feel_about_capsen',
  PERCENTAGE_CAPSEN = 'percentage_capsen',
  SHOPPING_CAPSEN = 'shopping_capsen',
  STYLE_MOST_MATTERS_CAPSEN = 'style_most_matters_capsen',
  FAVORITE_COLORS_CAPSEN = 'favorite_colors_capsen',
  LIKE_OR_DISLIKE_12_CAPSEN = 'like_or_dislike_12_capsen',
  LIKE_OR_DISLIKE_13_CAPSEN = 'like_or_dislike_13_capsen',
  LIKE_OR_DISLIKE_14_CAPSEN = 'like_or_dislike_14_capsen',
  LIKE_OR_DISLIKE_15_CAPSEN = 'like_or_dislike_15_capsen',
  LIKE_OR_DISLIKE_16_CAPSEN = 'like_or_dislike_16_capsen',
  LIKE_OR_DISLIKE_17_CAPSEN = 'like_or_dislike_17_capsen',
  LIKE_OR_DISLIKE_18_CAPSEN = 'like_or_dislike_18_capsen',
  LIKE_OR_DISLIKE_19_CAPSEN = 'like_or_dislike_19_capsen',
  STYLES_FEEL_LIKE_YOU_CAPSEN = 'styles_feel_like_you_capsen',
  URGE_3_CAPSEN = 'urge_3_capsen',
  BRAND_CAPSEN = 'brand_capsen',
  FIND_NEW_CLOTHES_CAPSEN = 'find_new_clothes_capsen',
  NOTHING_TO_WEAR_CAPSEN = 'nothing_to_wear_capsen',
  OLD_CLOTHES_CAPSEN = 'old_clothes_capsen',
  COMBINE_CLOTHES_CAPSEN = 'combine_clothes_capsen',
  OPTIMIZE_BUDGET_CAPSEN = 'optimize_budget_capsen',
  URGE_4_CAPSEN = 'urge_4_capsen',
  PREPARE_FLOW_CAPSEN = 'prepare_flow_capsen',
  EMAIL_CAPSEN = 'email_capsen',
  SUBSCRIPTIONS_CAPSEN = 'subscriptions_capsen',
  CANCEL_OFFER_CAPSEN = 'cancel_offer_capsen',
  SUB_UPSELL_CAPSEN = 'sub_upsell_capsen',
  UPSELL_CAPSEN = 'upsell_capsen',
  DOWNLOAD_CAPSEN = 'download_capsen',
  EMAIL_CONSENT_CAPSEN = 'email_consent_capsen',

  // STYLIO_CAPSULE2
  AGE_CAPSULE2 = 'age_capsule2',
  URGE_CAPSULE2 = 'urge_capsule2',
  HAIR_COLOR_CAPSULE2 = 'hair_color_capsule2',
  EYES_COLOR_CAPSULE2 = 'eyes_color_capsule2',
  JEWELRY_CAPSULE2 = 'jewelry_capsule2',
  BODY_SHAPE_CAPSULE2 = 'body_shape_capsule2',
  STYLIO_TO_HELP_CAPSULE2 = 'stylio_to_help_capsule2',
  TALL_CAPSULE2 = 'tall_capsule2',
  WEIGHT_CAPSULE2 = 'weight_capsule2',
  URGE_2_CAPSULE2 = 'urge_2_capsule2',
  FEEL_ABOUT_CAPSULE2 = 'feel_about_capsule2',
  PERCENTAGE_CAPSULE2 = 'percentage_capsule2',
  SHOPPING_CAPSULE2 = 'shopping_capsule2',
  STYLE_MOST_MATTERS_CAPSULE2 = 'style_most_matters_capsule2',
  FAVORITE_COLORS_CAPSULE2 = 'favorite_colors_capsule2',
  LIKE_OR_DISLIKE_CAPSULE2 = 'like_or_dislike_capsule2',
  LIKE_OR_DISLIKE_11_CAPSULE2 = 'like_or_dislike_11_capsule2',
  LIKE_OR_DISLIKE_12_CAPSULE2 = 'like_or_dislike_12_capsule2',
  LIKE_OR_DISLIKE_13_CAPSULE2 = 'like_or_dislike_13_capsule2',
  LIKE_OR_DISLIKE_14_CAPSULE2 = 'like_or_dislike_14_capsule2',
  LIKE_OR_DISLIKE_15_CAPSULE2 = 'like_or_dislike_15_capsule2',
  LIKE_OR_DISLIKE_16_CAPSULE2 = 'like_or_dislike_16_capsule2',
  LIKE_OR_DISLIKE_17_CAPSULE2 = 'like_or_dislike_17_capsule2',
  LIKE_OR_DISLIKE_18_CAPSULE2 = 'like_or_dislike_18_capsule2',
  LIKE_OR_DISLIKE_19_CAPSULE2 = 'like_or_dislike_19_capsule2',
  STYLES_FEEL_LIKE_YOU_CAPSULE2 = 'styles_feel_like_you_capsule2',
  URGE_3_CAPSULE2 = 'urge_3_capsule2',
  BRAND_CAPSULE2 = 'brand_capsule2',
  FIND_NEW_CLOTHES_CAPSULE2 = 'find_new_clothes_capsule2',
  NOTHING_TO_WEAR_CAPSULE2 = 'nothing_to_wear_capsule2',
  OLD_CLOTHES_CAPSULE2 = 'old_clothes_capsule2',
  COMBINE_CLOTHES_CAPSULE2 = 'combine_clothes_capsule2',
  OPTIMIZE_BUDGET_CAPSULE2 = 'optimize_budget_capsule2',
  URGE_4_CAPSULE2 = 'urge_4_capsule2',
  PREPARE_FLOW_CAPSULE2 = 'prepare_flow_capsule2',
  EMAIL_CAPSULE2 = 'email_capsule2',
  EMAIL_CONSENT_CAPSULE2 = 'email_consent_capsule2',
  SUBSCRIPTIONS_CAPSULE2 = 'subscriptions_capsule2',
  CANCEL_OFFER_CAPSULE2 = 'cancel_offer_capsule2',
  SUB_UPSELL_CAPSULE2 = 'sub_upsell_capsule2',
  UPSELL_CAPSULE2 = 'upsell_capsule2',
  DOWNLOAD_CAPSULE2 = 'download_capsule2',

  // STYLIO_CAPMOMS
  AGE_CAPMOMS = 'age_capmoms',
  URGE_CAPMOMS = 'urge_capmoms',
  HAIR_COLOR_CAPMOMS = 'hair_color_capmoms',
  EYES_COLOR_CAPMOMS = 'eyes_color_capmoms',
  JEWELRY_CAPMOMS = 'jewelry_capmoms',
  BODY_SHAPE_CAPMOMS = 'body_shape_capmoms',
  STYLIO_TO_HELP_CAPMOMS = 'stylio_to_help_capmoms',
  TALL_CAPMOMS = 'tall_capmoms',
  WEIGHT_CAPMOMS = 'weight_capmoms',
  URGE_2_CAPMOMS = 'urge_2_capmoms',
  FEEL_ABOUT_CAPMOMS = 'feel_about_capmoms',
  PERCENTAGE_CAPMOMS = 'percentage_capmoms',
  SHOPPING_CAPMOMS = 'shopping_capmoms',
  STYLE_MOST_MATTERS_CAPMOMS = 'style_most_matters_capmoms',
  FAVORITE_COLORS_CAPMOMS = 'favorite_colors_capmoms',
  LIKE_OR_DISLIKE_CAPMOMS = 'like_or_dislike_capmoms',
  LIKE_OR_DISLIKE_11_CAPMOMS = 'like_or_dislike_11_capmoms',
  LIKE_OR_DISLIKE_12_CAPMOMS = 'like_or_dislike_12_capmoms',
  LIKE_OR_DISLIKE_13_CAPMOMS = 'like_or_dislike_13_capmoms',
  LIKE_OR_DISLIKE_14_CAPMOMS = 'like_or_dislike_14_capmoms',
  LIKE_OR_DISLIKE_15_CAPMOMS = 'like_or_dislike_15_capmoms',
  LIKE_OR_DISLIKE_16_CAPMOMS = 'like_or_dislike_16_capmoms',
  LIKE_OR_DISLIKE_17_CAPMOMS = 'like_or_dislike_17_capmoms',
  LIKE_OR_DISLIKE_18_CAPMOMS = 'like_or_dislike_18_capmoms',
  LIKE_OR_DISLIKE_19_CAPMOMS = 'like_or_dislike_19_capmoms',
  STYLES_FEEL_LIKE_YOU_CAPMOMS = 'styles_feel_like_you_capmoms',
  URGE_3_CAPMOMS = 'urge_3_capmoms',
  URGE_4_CAPMOMS = 'urge_4_capmoms',
  TIME_CAPMOMS = 'time_capmoms',
  TYPICAL_DAY_CAPMOMS = 'typical_day_capmoms',
  YOUR_LOCATION_CAPMOMS = 'your_location_capmoms',
  BRAND_CAPMOMS = 'brand_capmoms',
  FIND_NEW_CLOTHES_CAPMOMS = 'find_new_clothes_capmoms',
  NOTHING_TO_WEAR_CAPMOMS = 'nothing_to_wear_capmoms',
  OLD_CLOTHES_CAPMOMS = 'old_clothes_capmoms',
  COMBINE_CLOTHES_CAPMOMS = 'combine_clothes_capmoms',
  OPTIMIZE_BUDGET_CAPMOMS = 'optimize_budget_capmoms',
  PREPARE_FLOW_CAPMOMS = 'prepare_flow_capmoms',
  EMAIL_CAPMOMS = 'email_capmoms',
  EMAIL_CONSENT_CAPMOMS = 'email_consent_capmoms',
  PRE_PAYWALL_OFFER_CAPMOMS = 'pre_paywall_offer_capmoms',
  SUBSCRIPTIONS_CAPMOMS = 'subscriptions_capmoms',
  CANCEL_OFFER_CAPMOMS = 'cancel_offer_capmoms',
  SUB_UPSELL_CAPMOMS = 'sub_upsell_capmoms',
  UPSELL_CAPMOMS = 'upsell_capmoms',
  DOWNLOAD_CAPMOMS = 'download_capmoms',

  // STYLIO_CAPMOMS4
  AGE_CAPMOMS4 = 'age_capmoms4',
  URGE_CAPMOMS4 = 'urge_capmoms4',
  HAIR_COLOR_CAPMOMS4 = 'hair_color_capmoms4',
  EYES_COLOR_CAPMOMS4 = 'eyes_color_capmoms4',
  JEWELRY_CAPMOMS4 = 'jewelry_capmoms4',
  BODY_SHAPE_CAPMOMS4 = 'body_shape_capmoms4',
  STYLIO_TO_HELP_CAPMOMS4 = 'stylio_to_help_capmoms4',
  TALL_CAPMOMS4 = 'tall_capmoms4',
  WEIGHT_CAPMOMS4 = 'weight_capmoms4',
  URGE_2_CAPMOMS4 = 'urge_2_capmoms4',
  FEEL_ABOUT_CAPMOMS4 = 'feel_about_capmoms4',
  PERCENTAGE_CAPMOMS4 = 'percentage_capmoms4',
  SHOPPING_CAPMOMS4 = 'shopping_capmoms4',
  STYLE_MOST_MATTERS_CAPMOMS4 = 'style_most_matters_capmoms4',
  FAVORITE_COLORS_CAPMOMS4 = 'favorite_colors_capmoms4',
  LIKE_OR_DISLIKE_CAPMOMS4 = 'like_or_dislike_capmoms4',
  LIKE_OR_DISLIKE_11_CAPMOMS4 = 'like_or_dislike_11_capmoms4',
  LIKE_OR_DISLIKE_12_CAPMOMS4 = 'like_or_dislike_12_capmoms4',
  LIKE_OR_DISLIKE_13_CAPMOMS4 = 'like_or_dislike_13_capmoms4',
  LIKE_OR_DISLIKE_14_CAPMOMS4 = 'like_or_dislike_14_capmoms4',
  LIKE_OR_DISLIKE_15_CAPMOMS4 = 'like_or_dislike_15_capmoms4',
  LIKE_OR_DISLIKE_16_CAPMOMS4 = 'like_or_dislike_16_capmoms4',
  LIKE_OR_DISLIKE_17_CAPMOMS4 = 'like_or_dislike_17_capmoms4',
  LIKE_OR_DISLIKE_18_CAPMOMS4 = 'like_or_dislike_18_capmoms4',
  LIKE_OR_DISLIKE_19_CAPMOMS4 = 'like_or_dislike_19_capmoms4',
  STYLES_FEEL_LIKE_YOU_CAPMOMS4 = 'styles_feel_like_you_capmoms4',
  URGE_3_CAPMOMS4 = 'urge_3_capmoms4',
  URGE_4_CAPMOMS4 = 'urge_4_capmoms4',
  TIME_CAPMOMS4 = 'time_capmoms4',
  TYPICAL_DAY_CAPMOMS4 = 'typical_day_capmoms4',
  BRAND_CAPMOMS4 = 'brand_capmoms4',
  FIND_NEW_CLOTHES_CAPMOMS4 = 'find_new_clothes_capmoms4',
  NOTHING_TO_WEAR_CAPMOMS4 = 'nothing_to_wear_capmoms4',
  OLD_CLOTHES_CAPMOMS4 = 'old_clothes_capmoms4',
  COMBINE_CLOTHES_CAPMOMS4 = 'combine_clothes_capmoms4',
  OPTIMIZE_BUDGET_CAPMOMS4 = 'optimize_budget_capmoms4',
  PREPARE_FLOW_CAPMOMS4 = 'prepare_flow_capmoms4',
  EMAIL_CAPMOMS4 = 'email_capmoms4',
  EMAIL_CONSENT_CAPMOMS4 = 'email_consent_capmoms4',
  PRE_PAYWALL_OFFER_CAPMOMS4 = 'pre_paywall_offer_capmoms4',
  SUBSCRIPTIONS_CAPMOMS4 = 'subscriptions_capmoms4',
  CANCEL_OFFER_CAPMOMS4 = 'cancel_offer_capmoms4',
  SUB_UPSELL_CAPMOMS4 = 'sub_upsell_capmoms4',
  UPSELL_CAPMOMS4 = 'upsell_capmoms4',
  DOWNLOAD_CAPMOMS4 = 'download_capmoms4',

  // STYLIO_CMP
  AGE_CMP = 'age_cmp',
  HAIR_COLOR_CMP = 'hair_color_cmp',
  EYES_COLOR_CMP = 'eyes_color_cmp',
  BODY_SHAPE_CMP = 'body_shape_cmp',
  STYLIO_TO_HELP_CMP = 'stylio_to_help_cmp',
  MAIN_GOAL_CMP = 'main_goal_cmp',
  WHERE_TO_SHOP_CMP = 'where_to_shop_cmp',
  WARDROBE_PERCENTAGE_CMP = 'wardrobe_percentage_cmp',
  SHOPPING_CMP = 'shopping_cmp',
  LIKE_OR_DISLIKE_CMP = 'like_or_dislike_cmp',
  LIKE_OR_DISLIKE_11_CMP = 'like_or_dislike_11_cmp',
  LIKE_OR_DISLIKE_12_CMP = 'like_or_dislike_12_cmp',
  LIKE_OR_DISLIKE_13_CMP = 'like_or_dislike_13_cmp',
  LIKE_OR_DISLIKE_14_CMP = 'like_or_dislike_14_cmp',
  LIKE_OR_DISLIKE_15_CMP = 'like_or_dislike_15_cmp',
  LIKE_OR_DISLIKE_16_CMP = 'like_or_dislike_16_cmp',
  LIKE_OR_DISLIKE_17_CMP = 'like_or_dislike_17_cmp',
  LIKE_OR_DISLIKE_18_CMP = 'like_or_dislike_18_cmp',
  LIKE_OR_DISLIKE_19_CMP = 'like_or_dislike_19_cmp',
  STYLES_FEEL_LIKE_YOU_CMP = 'styles_feel_like_you_cmp',
  URGE_1_CMP = 'urge_1_cmp',
  URGE_2_CMP = 'urge_2_cmp',
  URGE_3_CMP = 'urge_3_cmp',
  URGE_4_CMP = 'urge_4_cmp',
  URGE_5_CMP = 'urge_5_cmp',
  URGE_6_CMP = 'urge_6_cmp',
  FACE_SCAN_INTRO_CMP = 'face_scan_intro_cmp',
  FACE_SCAN_ANALYSIS_CMP = 'face_scan_analysis_cmp',
  URGE_7_CMP = 'urge_7_cmp',
  URGE_8_CMP = 'urge_8_cmp',
  STYLE_PROFILE_CMP = 'style_profile_cmp',
  WARDROBE_READY_CMP = 'wardrobe_ready_cmp',
  NOTHING_TO_WEAR_CMP = 'nothing_to_wear_cmp',
  WARDROBE_FEEL_CMP = 'wardrobe_feel_cmp',
  SHOPPING_BUDGET_CMP = 'shopping_budget_cmp',
  SHOPPING_PRIORITY_CMP = 'shopping_priority_cmp',
  AMAZON_FRUSTRATION_CMP = 'amazon_frustration_cmp',
  CURATED_LINKS_CMP = 'curated_links_cmp',
  LIFESTYLE_FOCUS_CMP = 'lifestyle_focus_cmp',
  OUTFIT_NEEDS_CMP = 'outfit_needs_cmp',
  WARDROBE_ALIGNS_CMP = 'wardrobe_aligns_cmp',
  LIFESTYLE_CHANGES_CMP = 'lifestyle_changes_cmp',
  STYLE_DRAWN_TO_CMP = 'style_drawn_to_cmp',
  OUTFIT_EMOTION_CMP = 'outfit_emotion_cmp',
  STYLE_DISCOVERY_CMP = 'style_discovery_cmp',
  WARDROBE_COLORS_CMP = 'wardrobe_colors_cmp',
  COLOR_CONFIDENCE_CMP = 'color_confidence_cmp',
  BODY_SHAPE_CONFIDENCE_CMP = 'body_shape_confidence_cmp',
  SHOW_OFF_FEATURES_CMP = 'show_off_features_cmp',
  PREPARE_FLOW_CMP = 'prepare_flow_cmp',
  EMAIL_CMP = 'email_cmp',
  NAME_CMP = 'name_cmp',
  READINESS_LEVEL_CMP = 'readiness_level_cmp',
  PRE_PAYWALL_OFFER_CMP = 'pre_paywall_offer_cmp',
  SUBSCRIPTIONS_CMP = 'subscriptions_cmp',
  CANCEL_OFFER_CMP = 'cancel_offer_cmp',
  AI_STYLIST_UPSELL_CMP = 'ai_stylist_upsell_cmp',
  SUB_UPSELL_CMP = 'sub_upsell_cmp',
  UPSELL_CMP = 'upsell_cmp',
  DOWNLOAD_CMP = 'download_cmp',
  FACE_UPSELL_CMP = 'face_upsell_cmp',
  BUNDLE_UPSELL_CMP = 'bundle_upsell_cmp',

  // STYLIO_ARCH
  AGE_ARCH = 'age_arch',
  SHOP_SMARTER_ARCH = 'shop_smarter_arch',
  URGE_ARCH = 'urge_arch',
  HAIR_COLOR_ARCH = 'hair_color_arch',
  EYES_COLOR_ARCH = 'eyes_color_arch',
  SKIN_COLOR_ARCH = 'skin_color_arch',
  CLIMAT_ARCH = 'climat_arch',
  JEWELRY_ARCH = 'jewelry_arch',
  BODY_SHAPE_ARCH = 'body_shape_arch',
  STYLIO_TO_HELP_ARCH = 'stylio_to_help_arch',
  MAIN_GOAL_ARCH = 'main_goal_arch',
  WHERE_TO_SHOP_ARCH = 'where_to_shop_arch',
  WARDROBE_PERCENTAGE_ARCH = 'wardrobe_percentage_arch',
  TALL_ARCH = 'tall_arch',
  WEIGHT_ARCH = 'weight_arch',
  FEEL_ABOUT_ARCH = 'feel_about_arch',
  PERCENTAGE_ARCH = 'percentage_arch',
  SHOPPING_ARCH = 'shopping_arch',
  STYLE_MOST_MATTERS_ARCH = 'style_most_matters_arch',
  FAVORITE_COLORS_ARCH = 'favorite_colors_arch',
  LIKE_OR_DISLIKE_ARCH = 'like_or_dislike_arch',
  LIKE_OR_DISLIKE_11_ARCH = 'like_or_dislike_11_arch',
  LIKE_OR_DISLIKE_12_ARCH = 'like_or_dislike_12_arch',
  LIKE_OR_DISLIKE_13_ARCH = 'like_or_dislike_13_arch',
  LIKE_OR_DISLIKE_14_ARCH = 'like_or_dislike_14_arch',
  LIKE_OR_DISLIKE_15_ARCH = 'like_or_dislike_15_arch',
  LIKE_OR_DISLIKE_16_ARCH = 'like_or_dislike_16_arch',
  LIKE_OR_DISLIKE_17_ARCH = 'like_or_dislike_17_arch',
  LIKE_OR_DISLIKE_18_ARCH = 'like_or_dislike_18_arch',
  LIKE_OR_DISLIKE_19_ARCH = 'like_or_dislike_19_arch',
  STYLES_FEEL_LIKE_YOU_ARCH = 'styles_feel_like_you_arch',
  URGE_1_ARCH = 'urge_1_arch',
  URGE_2_ARCH = 'urge_2_arch',
  URGE_3_ARCH = 'urge_3_arch',
  URGE_4_ARCH = 'urge_4_arch',
  URGE_5_ARCH = 'urge_5_arch',
  URGE_6_ARCH = 'urge_6_arch',
  URGE_7_ARCH = 'urge_7_arch',
  URGE_8_ARCH = 'urge_8_arch',
  URGE_9_ARCH = 'urge_9_arch',
  STYLE_PROFILE_ARCH = 'style_profile_arch',
  WARDROBE_READY_ARCH = 'wardrobe_ready_arch',
  TIME_ARCH = 'time_arch',
  TYPICAL_DAY_ARCH = 'typical_day_arch',
  BRAND_ARCH = 'brand_arch',
  FIND_NEW_CLOTHES_ARCH = 'find_new_clothes_arch',
  NOTHING_TO_WEAR_ARCH = 'nothing_to_wear_arch',
  ARCHETYPE_INTRO_ARCH = 'archetype_intro_arch',
  DRESSED_FEEL_ARCH = 'dressed_feel_arch',
  STYLE_MATTERS_MOST_ARCH = 'style_matters_most_arch',
  OUTFIT_VIBE_ARCH = 'outfit_vibe_arch',
  OUTFIT_COMPLIMENT_ARCH = 'outfit_compliment_arch',
  SHOP_PULLS_FIRST_ARCH = 'shop_pulls_first_arch',
  ARCHETYPE_LOADING_ARCH = 'archetype_loading_arch',
  ARCHETYPE_RESULT_ARCH = 'archetype_result_arch',
  LOOKING_FEMININE_ARCH = 'looking_feminine_arch',
  WARDROBE_CHANGED_ARCH = 'wardrobe_changed_arch',
  WALK_INTO_ROOM_ARCH = 'walk_into_room_arch',
  PERFECT_WEEKEND_ARCH = 'perfect_weekend_arch',
  WARDROBE_FEEL_ARCH = 'wardrobe_feel_arch',
  SHOPPING_BUDGET_ARCH = 'shopping_budget_arch',
  SHOPPING_PRIORITY_ARCH = 'shopping_priority_arch',
  AMAZON_FRUSTRATION_ARCH = 'amazon_frustration_arch',
  CURATED_LINKS_ARCH = 'curated_links_arch',
  LIFESTYLE_FOCUS_ARCH = 'lifestyle_focus_arch',
  OUTFIT_NEEDS_ARCH = 'outfit_needs_arch',
  WARDROBE_ALIGNS_ARCH = 'wardrobe_aligns_arch',
  LIFESTYLE_CHANGES_ARCH = 'lifestyle_changes_arch',
  STYLE_DRAWN_TO_ARCH = 'style_drawn_to_arch',
  OUTFIT_EMOTION_ARCH = 'outfit_emotion_arch',
  STYLE_DISCOVERY_ARCH = 'style_discovery_arch',
  WARDROBE_COLORS_ARCH = 'wardrobe_colors_arch',
  COLOR_CONFIDENCE_ARCH = 'color_confidence_arch',
  BODY_SHAPE_CONFIDENCE_ARCH = 'body_shape_confidence_arch',
  SHOW_OFF_FEATURES_ARCH = 'show_off_features_arch',
  OLD_CLOTHES_ARCH = 'old_clothes_arch',
  COMBINE_CLOTHES_ARCH = 'combine_clothes_arch',
  OPTIMIZE_BUDGET_ARCH = 'optimize_budget_arch',
  PREPARE_FLOW_ARCH = 'prepare_flow_arch',
  EMAIL_ARCH = 'email_arch',
  EMAIL_CONSENT_ARCH = 'email_consent_arch',
  NAME_ARCH = 'name_arch',
  READINESS_LEVEL_ARCH = 'readiness_level_arch',
  PRE_PAYWALL_OFFER_ARCH = 'pre_paywall_offer_arch',
  SUBSCRIPTIONS_ARCH = 'subscriptions_arch',
  CANCEL_OFFER_ARCH = 'cancel_offer_arch',
  SUB_UPSELL_ARCH = 'sub_upsell_arch',
  UPSELL_ARCH = 'upsell_arch',
  DOWNLOAD_ARCH = 'download_arch',
  // STYLIO_ARCH_IO
  AGE_ARCH_IO = 'age_arch_io',
  SHOP_SMARTER_ARCH_IO = 'shop_smarter_arch_io',
  URGE_ARCH_IO = 'urge_arch_io',
  HAIR_COLOR_ARCH_IO = 'hair_color_arch_io',
  EYES_COLOR_ARCH_IO = 'eyes_color_arch_io',
  SKIN_COLOR_ARCH_IO = 'skin_color_arch_io',
  CLIMAT_ARCH_IO = 'climat_arch_io',
  JEWELRY_ARCH_IO = 'jewelry_arch_io',
  BODY_SHAPE_ARCH_IO = 'body_shape_arch_io',
  STYLIO_TO_HELP_ARCH_IO = 'stylio_to_help_arch_io',
  MAIN_GOAL_ARCH_IO = 'main_goal_arch_io',
  WHERE_TO_SHOP_ARCH_IO = 'where_to_shop_arch_io',
  WARDROBE_PERCENTAGE_ARCH_IO = 'wardrobe_percentage_arch_io',
  TALL_ARCH_IO = 'tall_arch_io',
  WEIGHT_ARCH_IO = 'weight_arch_io',
  FEEL_ABOUT_ARCH_IO = 'feel_about_arch_io',
  PERCENTAGE_ARCH_IO = 'percentage_arch_io',
  SHOPPING_ARCH_IO = 'shopping_arch_io',
  STYLE_MOST_MATTERS_ARCH_IO = 'style_most_matters_arch_io',
  FAVORITE_COLORS_ARCH_IO = 'favorite_colors_arch_io',
  LIKE_OR_DISLIKE_ARCH_IO = 'like_or_dislike_arch_io',
  LIKE_OR_DISLIKE_11_ARCH_IO = 'like_or_dislike_11_arch_io',
  LIKE_OR_DISLIKE_12_ARCH_IO = 'like_or_dislike_12_arch_io',
  LIKE_OR_DISLIKE_13_ARCH_IO = 'like_or_dislike_13_arch_io',
  LIKE_OR_DISLIKE_14_ARCH_IO = 'like_or_dislike_14_arch_io',
  LIKE_OR_DISLIKE_15_ARCH_IO = 'like_or_dislike_15_arch_io',
  LIKE_OR_DISLIKE_16_ARCH_IO = 'like_or_dislike_16_arch_io',
  LIKE_OR_DISLIKE_17_ARCH_IO = 'like_or_dislike_17_arch_io',
  LIKE_OR_DISLIKE_18_ARCH_IO = 'like_or_dislike_18_arch_io',
  LIKE_OR_DISLIKE_19_ARCH_IO = 'like_or_dislike_19_arch_io',
  STYLES_FEEL_LIKE_YOU_ARCH_IO = 'styles_feel_like_you_arch_io',
  URGE_1_ARCH_IO = 'urge_1_arch_io',
  URGE_2_ARCH_IO = 'urge_2_arch_io',
  URGE_3_ARCH_IO = 'urge_3_arch_io',
  URGE_4_ARCH_IO = 'urge_4_arch_io',
  URGE_5_ARCH_IO = 'urge_5_arch_io',
  URGE_6_ARCH_IO = 'urge_6_arch_io',
  URGE_7_ARCH_IO = 'urge_7_arch_io',
  URGE_8_ARCH_IO = 'urge_8_arch_io',
  URGE_9_ARCH_IO = 'urge_9_arch_io',
  STYLE_PROFILE_ARCH_IO = 'style_profile_arch_io',
  WARDROBE_READY_ARCH_IO = 'wardrobe_ready_arch_io',
  TIME_ARCH_IO = 'time_arch_io',
  TYPICAL_DAY_ARCH_IO = 'typical_day_arch_io',
  BRAND_ARCH_IO = 'brand_arch_io',
  FIND_NEW_CLOTHES_ARCH_IO = 'find_new_clothes_arch_io',
  NOTHING_TO_WEAR_ARCH_IO = 'nothing_to_wear_arch_io',
  ARCHETYPE_INTRO_ARCH_IO = 'archetype_intro_arch_io',
  DRESSED_FEEL_ARCH_IO = 'dressed_feel_arch_io',
  STYLE_MATTERS_MOST_ARCH_IO = 'style_matters_most_arch_io',
  OUTFIT_VIBE_ARCH_IO = 'outfit_vibe_arch_io',
  OUTFIT_COMPLIMENT_ARCH_IO = 'outfit_compliment_arch_io',
  SHOP_PULLS_FIRST_ARCH_IO = 'shop_pulls_first_arch_io',
  ARCHETYPE_LOADING_ARCH_IO = 'archetype_loading_arch_io',
  ARCHETYPE_RESULT_ARCH_IO = 'archetype_result_arch_io',
  LOOKING_FEMININE_ARCH_IO = 'looking_feminine_arch_io',
  WARDROBE_CHANGED_ARCH_IO = 'wardrobe_changed_arch_io',
  WALK_INTO_ROOM_ARCH_IO = 'walk_into_room_arch_io',
  PERFECT_WEEKEND_ARCH_IO = 'perfect_weekend_arch_io',
  WARDROBE_FEEL_ARCH_IO = 'wardrobe_feel_arch_io',
  SHOPPING_BUDGET_ARCH_IO = 'shopping_budget_arch_io',
  SHOPPING_PRIORITY_ARCH_IO = 'shopping_priority_arch_io',
  AMAZON_FRUSTRATION_ARCH_IO = 'amazon_frustration_arch_io',
  CURATED_LINKS_ARCH_IO = 'curated_links_arch_io',
  LIFESTYLE_FOCUS_ARCH_IO = 'lifestyle_focus_arch_io',
  OUTFIT_NEEDS_ARCH_IO = 'outfit_needs_arch_io',
  WARDROBE_ALIGNS_ARCH_IO = 'wardrobe_aligns_arch_io',
  LIFESTYLE_CHANGES_ARCH_IO = 'lifestyle_changes_arch_io',
  STYLE_DRAWN_TO_ARCH_IO = 'style_drawn_to_arch_io',
  OUTFIT_EMOTION_ARCH_IO = 'outfit_emotion_arch_io',
  STYLE_DISCOVERY_ARCH_IO = 'style_discovery_arch_io',
  WARDROBE_COLORS_ARCH_IO = 'wardrobe_colors_arch_io',
  COLOR_CONFIDENCE_ARCH_IO = 'color_confidence_arch_io',
  BODY_SHAPE_CONFIDENCE_ARCH_IO = 'body_shape_confidence_arch_io',
  SHOW_OFF_FEATURES_ARCH_IO = 'show_off_features_arch_io',
  OLD_CLOTHES_ARCH_IO = 'old_clothes_arch_io',
  COMBINE_CLOTHES_ARCH_IO = 'combine_clothes_arch_io',
  OPTIMIZE_BUDGET_ARCH_IO = 'optimize_budget_arch_io',
  PREPARE_FLOW_ARCH_IO = 'prepare_flow_arch_io',
  EMAIL_ARCH_IO = 'email_arch_io',
  EMAIL_CONSENT_ARCH_IO = 'email_consent_arch_io',
  NAME_ARCH_IO = 'name_arch_io',
  READINESS_LEVEL_ARCH_IO = 'readiness_level_arch_io',
  PRE_PAYWALL_OFFER_ARCH_IO = 'pre_paywall_offer_arch_io',
  SUBSCRIPTIONS_ARCH_IO = 'subscriptions_arch_io',
  CANCEL_OFFER_ARCH_IO = 'cancel_offer_arch_io',
  AI_STYLIST_UPSELL_ARCH_IO = 'ai_stylist_upsell_arch_io',
  SUB_UPSELL_ARCH_IO = 'sub_upsell_arch_io',
  UPSELL_ARCH_IO = 'upsell_arch_io',
  DOWNLOAD_ARCH_IO = 'download_arch_io',

  // STYLIO_HUSAP
  AGE_HUSAP = 'age_husap',
  SHOP_SMARTER_HUSAP = 'shop_smarter_husap',
  URGE_HUSAP = 'urge_husap',
  HAIR_COLOR_HUSAP = 'hair_color_husap',
  EYES_COLOR_HUSAP = 'eyes_color_husap',
  SKIN_COLOR_HUSAP = 'skin_color_husap',
  CLIMAT_HUSAP = 'climat_husap',
  JEWELRY_HUSAP = 'jewelry_husap',
  BODY_SHAPE_HUSAP = 'body_shape_husap',
  STYLIO_TO_HELP_HUSAP = 'stylio_to_help_husap',
  MAIN_GOAL_HUSAP = 'main_goal_husap',
  WHERE_TO_SHOP_HUSAP = 'where_to_shop_husap',
  WARDROBE_PERCENTAGE_HUSAP = 'wardrobe_percentage_husap',
  TALL_HUSAP = 'tall_husap',
  WEIGHT_HUSAP = 'weight_husap',
  FEEL_ABOUT_HUSAP = 'feel_about_husap',
  PERCENTAGE_HUSAP = 'percentage_husap',
  SHOPPING_HUSAP = 'shopping_husap',
  STYLE_MOST_MATTERS_HUSAP = 'style_most_matters_husap',
  FAVORITE_COLORS_HUSAP = 'favorite_colors_husap',
  LIKE_OR_DISLIKE_HUSAP = 'like_or_dislike_husap',
  LIKE_OR_DISLIKE_11_HUSAP = 'like_or_dislike_11_husap',
  LIKE_OR_DISLIKE_12_HUSAP = 'like_or_dislike_12_husap',
  LIKE_OR_DISLIKE_13_HUSAP = 'like_or_dislike_13_husap',
  LIKE_OR_DISLIKE_14_HUSAP = 'like_or_dislike_14_husap',
  LIKE_OR_DISLIKE_15_HUSAP = 'like_or_dislike_15_husap',
  LIKE_OR_DISLIKE_16_HUSAP = 'like_or_dislike_16_husap',
  LIKE_OR_DISLIKE_17_HUSAP = 'like_or_dislike_17_husap',
  LIKE_OR_DISLIKE_18_HUSAP = 'like_or_dislike_18_husap',
  LIKE_OR_DISLIKE_19_HUSAP = 'like_or_dislike_19_husap',
  STYLES_FEEL_LIKE_YOU_HUSAP = 'styles_feel_like_you_husap',
  URGE_1_HUSAP = 'urge_1_husap',
  URGE_2_HUSAP = 'urge_2_husap',
  URGE_3_HUSAP = 'urge_3_husap',
  URGE_4_HUSAP = 'urge_4_husap',
  URGE_5_HUSAP = 'urge_5_husap',
  URGE_6_HUSAP = 'urge_6_husap',
  URGE_7_HUSAP = 'urge_7_husap',
  URGE_8_HUSAP = 'urge_8_husap',
  URGE_9_HUSAP = 'urge_9_husap',
  STYLE_PROFILE_HUSAP = 'style_profile_husap',
  WARDROBE_READY_HUSAP = 'wardrobe_ready_husap',
  TIME_HUSAP = 'time_husap',
  TYPICAL_DAY_HUSAP = 'typical_day_husap',
  BRAND_HUSAP = 'brand_husap',
  FIND_NEW_CLOTHES_HUSAP = 'find_new_clothes_husap',
  NOTHING_TO_WEAR_HUSAP = 'nothing_to_wear_husap',
  ARCHETYPE_INTRO_HUSAP = 'archetype_intro_husap',
  DRESSED_FEEL_HUSAP = 'dressed_feel_husap',
  STYLE_MATTERS_MOST_HUSAP = 'style_matters_most_husap',
  OUTFIT_VIBE_HUSAP = 'outfit_vibe_husap',
  OUTFIT_COMPLIMENT_HUSAP = 'outfit_compliment_husap',
  SHOP_PULLS_FIRST_HUSAP = 'shop_pulls_first_husap',
  ARCHETYPE_LOADING_HUSAP = 'archetype_loading_husap',
  ARCHETYPE_RESULT_HUSAP = 'archetype_result_husap',
  LOOKING_FEMININE_HUSAP = 'looking_feminine_husap',
  WARDROBE_CHANGED_HUSAP = 'wardrobe_changed_husap',
  WALK_INTO_ROOM_HUSAP = 'walk_into_room_husap',
  PERFECT_WEEKEND_HUSAP = 'perfect_weekend_husap',
  WARDROBE_FEEL_HUSAP = 'wardrobe_feel_husap',
  SHOPPING_BUDGET_HUSAP = 'shopping_budget_husap',
  SHOPPING_PRIORITY_HUSAP = 'shopping_priority_husap',
  AMAZON_FRUSTRATION_HUSAP = 'amazon_frustration_husap',
  CURATED_LINKS_HUSAP = 'curated_links_husap',
  LIFESTYLE_FOCUS_HUSAP = 'lifestyle_focus_husap',
  OUTFIT_NEEDS_HUSAP = 'outfit_needs_husap',
  WARDROBE_ALIGNS_HUSAP = 'wardrobe_aligns_husap',
  LIFESTYLE_CHANGES_HUSAP = 'lifestyle_changes_husap',
  STYLE_DRAWN_TO_HUSAP = 'style_drawn_to_husap',
  OUTFIT_EMOTION_HUSAP = 'outfit_emotion_husap',
  STYLE_DISCOVERY_HUSAP = 'style_discovery_husap',
  WARDROBE_COLORS_HUSAP = 'wardrobe_colors_husap',
  COLOR_CONFIDENCE_HUSAP = 'color_confidence_husap',
  BODY_SHAPE_CONFIDENCE_HUSAP = 'body_shape_confidence_husap',
  SHOW_OFF_FEATURES_HUSAP = 'show_off_features_husap',
  OLD_CLOTHES_HUSAP = 'old_clothes_husap',
  COMBINE_CLOTHES_HUSAP = 'combine_clothes_husap',
  OPTIMIZE_BUDGET_HUSAP = 'optimize_budget_husap',
  PREPARE_FLOW_HUSAP = 'prepare_flow_husap',
  EMAIL_HUSAP = 'email_husap',
  EMAIL_CONSENT_HUSAP = 'email_consent_husap',
  NAME_HUSAP = 'name_husap',
  READINESS_LEVEL_HUSAP = 'readiness_level_husap',
  PRE_PAYWALL_OFFER_HUSAP = 'pre_paywall_offer_husap',
  SUBSCRIPTIONS_HUSAP = 'subscriptions_husap',
  CANCEL_OFFER_HUSAP = 'cancel_offer_husap',
  AI_STYLIST_UPSELL_HUSAP = 'ai_stylist_upsell_husap',
  FACE_STYLING_PDF_UPSELL_HUSAP = 'face_styling_pdf_upsell_husap',
  PROPORTIONS_PDF_UPSELL_HUSAP = 'proportions_pdf_upsell_husap',
  DOWNLOAD_HUSAP = 'download_husap',

  // STYLIO_1
  AGE_STYLIO_1 = 'age_stylio_1',
  URGE_STYLIO_1 = 'urge_stylio_1',
  HAIR_COLOR_STYLIO_1 = 'hair_color_stylio_1',
  EYES_COLOR_STYLIO_1 = 'eyes_color_stylio_1',
  JEWELRY_STYLIO_1 = 'jewelry_stylio_1',
  BODY_SHAPE_STYLIO_1 = 'body_shape_stylio_1',
  STYLIO_TO_HELP_STYLIO_1 = 'stylio_to_help_stylio_1',
  TALL_STYLIO_1 = 'tall_stylio_1',
  WEIGHT_STYLIO_1 = 'weight_stylio_1',
  URGE_2_STYLIO_1 = 'urge_2_stylio_1',
  SHOPPING_STYLIO_1 = 'shopping_stylio_1',
  STYLE_MOST_MATTERS_STYLIO_1 = 'style_most_matters_stylio_1',
  FAVORITE_COLORS_STYLIO_1 = 'favorite_colors_stylio_1',
  LIKE_OR_DISLIKE_STYLIO_1 = 'like_or_dislike_stylio_1',
  LIKE_OR_DISLIKE_11_STYLIO_1 = 'like_or_dislike_11_stylio_1',
  LIKE_OR_DISLIKE_12_STYLIO_1 = 'like_or_dislike_12_stylio_1',
  LIKE_OR_DISLIKE_13_STYLIO_1 = 'like_or_dislike_13_stylio_1',
  LIKE_OR_DISLIKE_14_STYLIO_1 = 'like_or_dislike_14_stylio_1',
  LIKE_OR_DISLIKE_15_STYLIO_1 = 'like_or_dislike_15_stylio_1',
  LIKE_OR_DISLIKE_16_STYLIO_1 = 'like_or_dislike_16_stylio_1',
  LIKE_OR_DISLIKE_17_STYLIO_1 = 'like_or_dislike_17_stylio_1',
  LIKE_OR_DISLIKE_18_STYLIO_1 = 'like_or_dislike_18_stylio_1',
  LIKE_OR_DISLIKE_19_STYLIO_1 = 'like_or_dislike_19_stylio_1',
  STYLES_FEEL_LIKE_YOU_STYLIO_1 = 'styles_feel_like_you_stylio_1',
  URGE_4_STYLIO_1 = 'urge_4_stylio_1',
  BRAND_STYLIO_1 = 'brand_stylio_1',
  FIND_NEW_CLOTHES_STYLIO_1 = 'find_new_clothes_stylio_1',
  NOTHING_TO_WEAR_STYLIO_1 = 'nothing_to_wear_stylio_1',
  OLD_CLOTHES_STYLIO_1 = 'old_clothes_stylio_1',
  COMBINE_CLOTHES_STYLIO_1 = 'combine_clothes_stylio_1',
  OUTFIT_LOOK_STYLIO_1 = 'outfit_look_stylio_1',
  OPTIMIZE_BUDGET_STYLIO_1 = 'optimize_budget_stylio_1',
  EVERYDAY_LIFESTYLE_STYLIO_1 = 'everyday_lifestyle_stylio_1',
  CLIMAT_STYLIO_1 = 'climat_stylio_1',
  URGE_3_STYLIO_1 = 'urge_3_stylio_1',
  PREPARE_FLOW_STYLIO_1 = 'prepare_flow_stylio_1',
  EMAIL_STYLIO_1 = 'email_stylio_1',
  EMAIL_CONSENT_STYLIO_1 = 'email_consent_stylio_1',
  NAME_STYLIO_1 = 'name_stylio_1',
  SUBSCRIPTIONS_STYLIO_1 = 'subscriptions_stylio_1',
  LAST_CHANCE_OFFER_STYLIO_1 = 'last_chance_offer_stylio_1',
  CANCEL_OFFER_STYLIO_1 = 'cancel_offer_stylio_1',
  SUB_UPSELL_STYLIO_1 = 'sub_upsell_stylio_1',
  UPSELL_STYLIO_1 = 'upsell_stylio_1',
  DOWNLOAD_STYLIO_1 = 'download_stylio_1',
  START_SCREEN_STYLIO_1 = 'start_screen_stylio_1',
  // STYLIO_PLUS
  AGE_STYLIO_PLUS = 'age_stylio_plus',
  URGE_STYLIO_PLUS = 'urge_stylio_plus',
  HAIR_COLOR_STYLIO_PLUS = 'hair_color_stylio_plus',
  EYES_COLOR_STYLIO_PLUS = 'eyes_color_stylio_plus',
  JEWELRY_STYLIO_PLUS = 'jewelry_stylio_plus',
  BODY_SHAPE_STYLIO_PLUS = 'body_shape_stylio_plus',
  STYLIO_TO_HELP_STYLIO_PLUS = 'stylio_to_help_stylio_plus',
  TALL_STYLIO_PLUS = 'tall_stylio_plus',
  WEIGHT_STYLIO_PLUS = 'weight_stylio_plus',
  HIGHLIGHT_LOOK_STYLIO_PLUS = 'highlight_look_stylio_plus',
  CLOTHES_FIT_STYLIO_PLUS = 'clothes_fit_stylio_plus',
  URGE_2_STYLIO_PLUS = 'urge_2_stylio_plus',
  SHOPPING_STYLIO_PLUS = 'shopping_stylio_plus',
  STYLE_MOST_MATTERS_STYLIO_PLUS = 'style_most_matters_stylio_plus',
  FAVORITE_COLORS_STYLIO_PLUS = 'favorite_colors_stylio_plus',
  LIKE_OR_DISLIKE_STYLIO_PLUS = 'like_or_dislike_stylio_plus',
  LIKE_OR_DISLIKE_11_STYLIO_PLUS = 'like_or_dislike_11_stylio_plus',
  LIKE_OR_DISLIKE_12_STYLIO_PLUS = 'like_or_dislike_12_stylio_plus',
  LIKE_OR_DISLIKE_13_STYLIO_PLUS = 'like_or_dislike_13_stylio_plus',
  LIKE_OR_DISLIKE_14_STYLIO_PLUS = 'like_or_dislike_14_stylio_plus',
  LIKE_OR_DISLIKE_15_STYLIO_PLUS = 'like_or_dislike_15_stylio_plus',
  LIKE_OR_DISLIKE_16_STYLIO_PLUS = 'like_or_dislike_16_stylio_plus',
  LIKE_OR_DISLIKE_17_STYLIO_PLUS = 'like_or_dislike_17_stylio_plus',
  STYLES_FEEL_LIKE_YOU_STYLIO_PLUS = 'styles_feel_like_you_stylio_plus',
  URGE_4_STYLIO_PLUS = 'urge_4_stylio_plus',
  BRAND_STYLIO_PLUS = 'brand_stylio_plus',
  FIND_NEW_CLOTHES_STYLIO_PLUS = 'find_new_clothes_stylio_plus',
  NOTHING_TO_WEAR_STYLIO_PLUS = 'nothing_to_wear_stylio_plus',
  OLD_CLOTHES_STYLIO_PLUS = 'old_clothes_stylio_plus',
  COMBINE_CLOTHES_STYLIO_PLUS = 'combine_clothes_stylio_plus',
  OPTIMIZE_BUDGET_STYLIO_PLUS = 'optimize_budget_stylio_plus',
  URGE_3_STYLIO_PLUS = 'urge_3_stylio_plus',
  PREPARE_FLOW_STYLIO_PLUS = 'prepare_flow_stylio_plus',
  EMAIL_STYLIO_PLUS = 'email_stylio_plus',
  EMAIL_CONSENT_STYLIO_PLUS = 'email_consent_stylio_plus',
  NAME_STYLIO_PLUS = 'name_stylio_plus',
  SUBSCRIPTIONS_STYLIO_PLUS = 'subscriptions_stylio_plus',
  LAST_CHANCE_OFFER_STYLIO_PLUS = 'last_chance_offer_stylio_plus',
  CANCEL_OFFER_STYLIO_PLUS = 'cancel_offer_stylio_plus',
  SUB_UPSELL_STYLIO_PLUS = 'sub_upsell_stylio_plus',
  UPSELL_STYLIO_PLUS = 'upsell_stylio_plus',
  DOWNLOAD_STYLIO_PLUS = 'download_stylio_plus',
  // STYLIO_CAPSULE_61
  SUBSCRIPTIONS_CAPSULE_61 = 'subscriptions_capsule_61',
  SUB_UPSELL_CAPSULE_61 = 'sub_upsell_capsule_61',
  FACE_STYLING_PDF_UPSELL_CAPSULE_61 = 'face_styling_pdf_upsell_capsule_61',
  PROPORTIONS_PDF_UPSELL_CAPSULE_61 = 'proportions_pdf_upsell_capsule_61',
  DOWNLOAD_CAPSULE_61 = 'download_capsule_61',
  // STYLIO_CAPSULE_71
  SUBSCRIPTIONS_CAPSULE_71 = 'subscriptions_capsule_71',
  SUB_UPSELL_CAPSULE_71 = 'sub_upsell_capsule_71',
  FACE_STYLING_PDF_UPSELL_CAPSULE_71 = 'face_styling_pdf_upsell_capsule_71',
  PROPORTIONS_PDF_UPSELL_CAPSULE_71 = 'proportions_pdf_upsell_capsule_71',
  DOWNLOAD_CAPSULE_71 = 'download_capsule_71',
  // STYLIO_CAPSULE_81
  SUBSCRIPTIONS_CAPSULE_81 = 'subscriptions_capsule_81',
  SUB_UPSELL_CAPSULE_81 = 'sub_upsell_capsule_81',
  FACE_STYLING_PDF_UPSELL_CAPSULE_81 = 'face_styling_pdf_upsell_capsule_81',
  PROPORTIONS_PDF_UPSELL_CAPSULE_81 = 'proportions_pdf_upsell_capsule_81',
  DOWNLOAD_CAPSULE_81 = 'download_capsule_81',
  // STYLIO_ARCH_61
  SUBSCRIPTIONS_ARCH_61 = 'subscriptions_arch_61',
  SUB_UPSELL_ARCH_61 = 'sub_upsell_arch_61',
  FACE_STYLING_PDF_UPSELL_ARCH_61 = 'face_styling_pdf_upsell_arch_61',
  PROPORTIONS_PDF_UPSELL_ARCH_61 = 'proportions_pdf_upsell_arch_61',
  DOWNLOAD_ARCH_61 = 'download_arch_61',
  // STYLIO_ARCH_71
  SUBSCRIPTIONS_ARCH_71 = 'subscriptions_arch_71',
  SUB_UPSELL_ARCH_71 = 'sub_upsell_arch_71',
  FACE_STYLING_PDF_UPSELL_ARCH_71 = 'face_styling_pdf_upsell_arch_71',
  PROPORTIONS_PDF_UPSELL_ARCH_71 = 'proportions_pdf_upsell_arch_71',
  DOWNLOAD_ARCH_71 = 'download_arch_71',
  // STYLIO_ARCH_81
  SUBSCRIPTIONS_ARCH_81 = 'subscriptions_arch_81',
  SUB_UPSELL_ARCH_81 = 'sub_upsell_arch_81',
  FACE_STYLING_PDF_UPSELL_ARCH_81 = 'face_styling_pdf_upsell_arch_81',
  PROPORTIONS_PDF_UPSELL_ARCH_81 = 'proportions_pdf_upsell_arch_81',
  DOWNLOAD_ARCH_81 = 'download_arch_81',
}
